import React from 'react';
import { useRoutes } from 'react-router-dom';
import * as Sentry from "@sentry/react";
import { useAuthentication } from '../modules/auth/AuthenticationProvider';
import { ClientWrapper as Client } from '../modules/client/Client';
import { Clients } from '../modules/clients/Clients';
import { ContractorWrapper as Contractor } from '../modules/contractor/Contractor';
import { Contractors } from '../modules/contractors/Contractors';
import { Error } from '../modules/Error';
import { NoPermissionError } from '../modules/NoPermissionError';
import { Home } from '../modules/home/Home';
import { SettingsWrapper as Settings } from '../modules/settings/Settings';
import { StatsWrapper as Stats } from '../modules/stats/Stats';
import { EditTransportOrder as TransportOrder, NewTransportOrder } from '../modules/transport-order';
import { TransportOrders } from '../modules/transport-orders/TransportOrders';
import { Sidebar } from './Sidebar';
import { LoggedInUserTopNavbar, NotLoggedInUserTopNavbar } from './TopNavbar';
import { HasPermission } from '../components/auth/HasPermission';
import { Permission } from '../domain/permissions';

const LayoutComponent = () => {
    const routes = useRoutes([
        { path: '/', element: <Home />, errorElement: <Error /> },

        {
            path: '/transport-orders',
            element: <HasPermission permission={Permission.TRANSPORT_ORDERS_READ_ALL} fallback={<NoPermissionError />}><TransportOrders /></HasPermission>
        },
        {
            path: '/transport-orders/:transportOrderId',
            element: <HasPermission permission={Permission.TRANSPORT_ORDERS_READ_ONE} fallback={<NoPermissionError />}><TransportOrder /></HasPermission>
        },
        {
            path: '/new-transport-order',
            element: <HasPermission permission={Permission.TRANSPORT_ORDERS_CREATE} fallback={<NoPermissionError />}><NewTransportOrder /></HasPermission>
        },

        {
            path: '/contractors',
            element: <HasPermission permission={Permission.CONTRACTORS_READ_ALL} fallback={<NoPermissionError />}><Contractors /></HasPermission>
        },
        {
            path: '/contractors/:contractorId',
            element: <HasPermission permission={Permission.CONTRACTORS_READ_ONE} fallback={<NoPermissionError />}><Contractor /></HasPermission>
        },

        {
            path: '/clients',
            element: <HasPermission permission={Permission.CLIENTS_READ_ALL} fallback={<NoPermissionError />}><Clients /></HasPermission>
        },
        {
            path: '/clients/:clientId',
            element: <HasPermission permission={Permission.CLIENTS_READ_ONE} fallback={<NoPermissionError />}><Client /></HasPermission>
        },

        {
            path: '/stats',
            element: <HasPermission anyPermission={[Permission.STATS_READ_ALL, Permission.STATS_READ_OWN]} fallback={<NoPermissionError />}><Stats /></HasPermission>
        },

        {
            path: '/settings',
            element: <HasPermission permission={Permission.SETTINGS_VIEW} fallback={<NoPermissionError />}><Settings /></HasPermission>
        },
    ]);

    const { currentUser } = useAuthentication();

    return <div className="d-flex flex-row">
        <aside className="bg-white h-100vh">
            <Sidebar />
        </aside>
        <main className="d-flex flex-column flex-grow-1 bg-body-tertiary">
            <div>
                {currentUser ? <LoggedInUserTopNavbar /> : <NotLoggedInUserTopNavbar />}
            </div>
            <div className="d-flex flex-grow-1 p-4 flex-column">
                {currentUser && routes}
            </div>
        </main>
    </div>;
};

export const Layout = Sentry.withSentryReactRouterV6Routing(LayoutComponent);
